/* src/app/pages/credit-lines/credit-lines.component.scss */
.default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-flex-column {
  display: flex;
  flex-flow: column;
}
.default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
.rounded-circle {
  border-radius: 50%;
}
:host {
  display: flex;
  flex-direction: column;
  background: var(--cds-background-accent);
  padding: 32px 24px;
}
span {
  color: var(--cds-text-strong);
}
main {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.investments-header {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 10px;
}
.cards-grid {
  display: grid;
  grid-template-columns: 350px 1fr 1fr 1fr;
  gap: 24px;
  align-items: stretch;
}
.cards-column {
  display: grid;
  grid-template-rows: 1fr 1fr;
  gap: 24px;
}
.cards-row {
  display: flex;
  gap: 24px;
  grid-row: 2;
}
.cards-row .card-item {
  flex: 1;
  min-height: 100px;
  height: 100%;
}
.card-item {
  min-height: 120px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.cards-column .card-item {
  height: 100%;
}
.cards-row .card-item {
  min-height: 120px;
  height: 100%;
}
.cds-card {
  padding: 0px 24px 24px 24px;
}
.cds-card .card-header .card-title {
  gap: 8px;
  font-size: 20px;
  font-weight: 600;
  color: var(--cds-text-strong);
}
.card-total-balance {
  justify-content: center;
  grid-row: 1;
}
.card-total-balance .card-value {
  font-weight: 600;
  font-size: 20px;
}
.card-overdue {
  justify-content: center;
}
.card-overdue .card-value {
  font-weight: 600;
  color: var(--cds-expense);
  font-size: 20px;
}
.card-active {
  justify-content: center;
}
.card-active .card-value {
  font-weight: 600;
  color: var(--cds-revenue);
  font-size: 20px;
}
.card-institutions .institutions-list {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.card-institutions .institution-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}
.card-institutions .institution-bar {
  width: 6px;
  height: 24px;
  border-radius: 3px;
  flex-shrink: 0;
}
.card-institutions .institution-name {
  flex: 1;
  font-weight: 500;
}
.card-institutions .institution-value {
  font-weight: 600;
}
.card-credit-lines .credit-lines-list {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  flex: 1;
}
.card-credit-lines .credit-line-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  flex: 1;
}
.card-credit-lines .credit-line-bar {
  width: 6px;
  height: 24px;
  border-radius: 3px;
  flex-shrink: 0;
}
.card-credit-lines .credit-line-name-container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}
.card-credit-lines .credit-line-value-container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.card-credit-lines .credit-line-value-container i {
  flex-shrink: 0;
}
.card-credit-lines .credit-line-value {
  font-weight: 600;
  color: var(--cds-text-strong);
}
.card-total-institutions .total-institutions-list {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.card-total-institutions .total-institution-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}
.card-total-institutions .total-institution-bar {
  width: 6px;
  height: 24px;
  border-radius: 3px;
  flex-shrink: 0;
}
.card-total-institutions .total-institution-name {
  flex: 1;
  font-weight: 500;
}
.card-total-institutions .total-institution-value {
  font-weight: 600;
  color: var(--cds-text-strong);
}
.tabs-container {
  margin-top: 14px;
  margin-bottom: 32px;
}
.list-end-indicator {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}
/*# sourceMappingURL=credit-lines.component.css.map */
